/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespCollectionsComponents_collectionsModules$ref: FragmentReference;
export type SbRespCollectionsComponents_collectionsModules = {|
  +gridType: ?string,
  +$refType: SbRespCollectionsComponents_collectionsModules$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespCollectionsComponents_collectionsModules",
  "type": "CollectionsModulesMainContent",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "gridType",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'b673457bbc18d4bffd6a0f1431cad0b3';
module.exports = node;
